import React from 'react';
import { Shield, Eye, Database, Lock, Trash2 } from 'lucide-react';
import './LegalPages.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <img src="/logo.png" alt="Logo" className="legal-logo" />
          <Shield size={48} />
          <h1>Politique de Confidentialité</h1>
          <p className="legal-subtitle">Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')}</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2><Shield size={24} /> 1. Collecte des données</h2>
            <p>
              Discord Maintenance Panel collecte uniquement les données nécessaires 
              au fonctionnement du service:
            </p>
            <ul>
              <li><strong>Données Discord:</strong> ID utilisateur, username, avatar, et liste des serveurs (via OAuth2)</li>
              <li><strong>Données de maintenance:</strong> Statut de maintenance, messages, et horaires</li>
              <li><strong>Données techniques:</strong> Logs de connexion et d'erreurs pour le support</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2><Eye size={24} /> 2. Utilisation des données</h2>
            <p>
              Vos données sont utilisées exclusivement pour:
            </p>
            <ul>
              <li>Vérifier vos permissions administrateur sur les serveurs Discord</li>
              <li>Gérer les statuts de maintenance des serveurs</li>
              <li>Améliorer le service et résoudre les problèmes techniques</li>
              <li>Assurer la sécurité et la prévention des abus</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2><Database size={24} /> 3. Stockage des données</h2>
            <p>
              Toutes les données sont stockées localement dans une base de données SQLite 
              sur le serveur hébergeant l'application. Aucune donnée n'est transmise 
              à des tiers à des fins commerciales.
            </p>
          </section>

          <section className="legal-section">
            <h2><Lock size={24} /> 4. Sécurité des données</h2>
            <p>
              Nous mettons en œuvre des mesures de sécurité appropriées pour protéger 
              vos données contre l'accès non autorisé, la modification ou la destruction. 
              Ces mesures incluent:
            </p>
            <ul>
              <li>Authentification via Discord OAuth2</li>
              <li>Vérification des permissions administrateur</li>
              <li>Connexions HTTPS chiffrées</li>
              <li>Accès restreint aux données sensibles</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2><Trash2 size={24} /> 5. Droits des utilisateurs</h2>
            <p>
              Conformément au RGPD, vous disposez des droits suivants:
            </p>
            <ul>
              <li><strong>Droit d'accès:</strong> Demander une copie de vos données</li>
              <li><strong>Droit de rectification:</strong> Demander la correction de vos données</li>
              <li><strong>Droit à l'effacement:</strong> Demander la suppression de vos données</li>
              <li><strong>Droit à la portabilité:</strong> Demander le transfert de vos données</li>
              <li><strong>Droit d'opposition:</strong> Vous opposer au traitement de vos données</li>
            </ul>
            <p>Pour exercer ces droits, contactez l'administrateur du service.</p>
          </section>

          <section className="legal-section">
            <h2><Shield size={24} /> 6. Conservation des données</h2>
            <p>
              Les données sont conservées uniquement tant que nécessaire pour le fonctionnement 
              du service. Les données de maintenance sont conservées pour l'historique 
              et peuvent être supprimées sur demande.
            </p>
          </section>

          <section className="legal-section">
            <h2><Eye size={24} /> 7. Cookies</h2>
            <p>
              Ce service utilise des cookies de session uniquement pour l'authentification. 
              Ces cookies sont essentiels au fonctionnement du service et ne sont pas utilisés 
              à des fins de suivi ou de publicité.
            </p>
          </section>

          <section className="legal-section">
            <h2><Lock size={24} /> 8. Modifications de la politique</h2>
            <p>
              Nous nous réservons le droit de modifier cette politique de confidentialité. 
              Les modifications seront notifiées aux utilisateurs et prendront effet 
              dès leur publication.
            </p>
          </section>

          <section className="legal-section">
            <h2><Shield size={24} /> 9. Contact</h2>
            <p>
              Pour toute question concernant cette politique de confidentialité ou 
              vos données personnelles, contactez l'administrateur du service.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
